"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toBeeMode = exports.BeeModes = void 0;
var BeeModes;
(function (BeeModes) {
    BeeModes["FULL"] = "full";
    BeeModes["LIGHT"] = "light";
    BeeModes["ULTRA_LIGHT"] = "ultra-light";
    BeeModes["DEV"] = "dev";
})(BeeModes = exports.BeeModes || (exports.BeeModes = {}));
function toBeeMode(value) {
    switch (value) {
        case 'full':
            return BeeModes.FULL;
        case 'light':
            return BeeModes.LIGHT;
        case 'ultra-light':
            return BeeModes.ULTRA_LIGHT;
        case 'dev':
            return BeeModes.DEV;
        default:
            throw new Error(`Unknown Bee mode: ${value}`);
    }
}
exports.toBeeMode = toBeeMode;
